<template>
  <div class="d-flex align-items-center font-weight-bold">
    <i18n-n tag="span" :value="value" :format="currencyFormat" :locale="computedLocale">
      <template #currency="[]">
        <span>{{ symbol }}</span>
      </template>
      <template #integer="slotProps">
        <span>{{ slotProps.integer }}</span>
      </template>
      <template #decimal="slotProps">
        <span style="display: none">{{ slotProps.decimal }}</span>
      </template>
      <template #fraction="slotProps">
        <span style="display: none">{{ slotProps.fraction }}</span>
      </template>
    </i18n-n>
  </div>
</template>

<script>
export default {
  name: 'CurrencyFormatted',
  props: {
    value: {
      type: Number,
      required: true
    },
    currencyConfig: {
      type: Object,
      required: true
    },
    locale: {
      type: String,
      default: null
    }
  },
  computed: {
    symbol() {
      return this.currencyConfig.symbol || this.currencyConfig.code
    },
    currencyFormat() {
      return {
        key: 'currency',
        currency: this.currencyConfig.code,
        currencyDisplay: 'symbol'
      }
    },
    computedLocale() {
      return this.locale || this.$i18n.locale
    }
  }
}
</script>
